export default function compress(file, { maxWidth = 1600, maxHeight = 1200 } = {}) {
  const reader = new FileReader();
  reader.readAsDataURL(file);

  return new Promise((resolve, reject) => {
    reader.onload = event => {
      const img = new Image();
      img.src = event.target.result;

      img.onload = function onload() {
        let { width, height } = img;
        let maxW = maxWidth;
        let maxH = maxHeight;

        if (height > width) {
          maxW = maxHeight;
          maxH = maxWidth;
        }

        if (height <= maxH && width <= maxW) {
          resolve(file);
          return;
        }

        width = maxW < width ? maxW : width;
        const ratio = img.width / img.height;
        height = width / ratio;

        if (height > maxH) {
          height = maxH;
          width = height * ratio;
        }

        const elem = document.createElement('canvas');
        elem.width = width;
        elem.height = height;
        const ctx = elem.getContext('2d');
        // img.width and img.height will contain the original dimensions
        ctx.drawImage(img, 0, 0, width, height);
        ctx.canvas.toBlob(
          blob => {
            resolve(
              new File([blob], file.name, {
                type: 'image/jpeg',
                lastModified: Date.now(),
              }),
            );
          },
          'image/jpeg',
          0.9,
        );
      };

      reader.onerror = reject;
    };
  });
}
